// Numeric path segments are patient/consult ids; they must not reach
// third-party telemetry (AppSignal). Query strings carry ids too (consultId,
// threadId), so they are dropped entirely.
export function scrubIdsFromPath(path: string): string {
  return path.split('?')[0].replace(/\/\d+(?=\/|$)/g, '/:id')
}
